import { SMLRouteNames } from '../../../routing/sml/SMLRoutes';

/** The paths of the Outreach pages that hold an id (spec 2026-10-11 §6). The router adds `/app`. */

export function outreachCampaignPath(campaignUuid: string): string {
  return `/${SMLRouteNames.outreach}/campaigns/${encodeURIComponent(campaignUuid)}`;
}

export function outreachReviewPath(campaignUuid: string): string {
  return `${outreachCampaignPath(campaignUuid)}/review`;
}

export function outreachReplyPath(replyUuid: string): string {
  return `/${SMLRouteNames.outreach}/inbox/${encodeURIComponent(replyUuid)}`;
}

/** Find (design t2 "Find more curators", t3 "See them"): `/outreach/find?song=`. */
export function outreachFindPath(song?: string | null): string {
  const suffix = song === undefined || song === null || song === '' ? '' : `?song=${encodeURIComponent(song)}`;
  return `/${SMLRouteNames.outreach}/find${suffix}`;
}

/** The tabs of the campaign page (design outreach-v2 g1, n1): `?tab=`. */
export type CampaignTab = 'today' | 'people' | 'results';

export const CAMPAIGN_TABS: readonly CampaignTab[] = ['today', 'people', 'results'];

/** The tab of a `?tab=` value; an unknown or empty value is Today. */
export function campaignTabOf(value: string | null): CampaignTab {
  return CAMPAIGN_TABS.find((tab) => tab === value) ?? 'today';
}

/** One tab of the campaign page. Today has no `?tab=`. */
export function outreachCampaignTabPath(campaignUuid: string, tab: CampaignTab): string {
  return tab === 'today' ? outreachCampaignPath(campaignUuid) : `${outreachCampaignPath(campaignUuid)}?tab=${tab}`;
}

/** The results of one campaign (design outreach-v2 n1): the Results tab of the campaign page. */
export function outreachResultsPath(campaignUuid: string): string {
  return outreachCampaignTabPath(campaignUuid, 'results');
}

/** The results of every song side by side (design outreach-v2 n2): `/outreach/results`. */
export function outreachAllResultsPath(): string {
  return `/${SMLRouteNames.outreach}/results`;
}

export interface OutreachBuilderOptions {
  song?: string | null;
  campaign?: string | null;
  /** The step that a draft opens on (`builderSteps.ts`; old step names still parse). */
  step?: string | null;
}

/** The campaign setup (design outreach-v2 b to f): `/outreach/campaigns/new?song=&campaign=&step=`. */
export function outreachBuilderPath(options: OutreachBuilderOptions = {}): string {
  const query = new URLSearchParams();
  if (options.song !== undefined && options.song !== null) {
    query.set('song', options.song);
  }
  if (options.campaign !== undefined && options.campaign !== null) {
    query.set('campaign', options.campaign);
  }
  if (options.step !== undefined && options.step !== null) {
    query.set('step', options.step);
  }
  const search = query.toString();
  return `/${SMLRouteNames.outreach}/campaigns/new${search === '' ? '' : `?${search}`}`;
}
